import { type SubscriptionContract as SubscriptionContractType } from '../../hooks/useSubscriptionContract';

export const formatDate = (dateString: string | null): string => {
  if (!dateString) return 'N/A';
  try {
    return new Date(dateString).toLocaleString();
  } catch {
    return dateString;
  }
};

export const getPhoneNumber = (contract: SubscriptionContractType): string => {
  if (contract.customer?.defaultPhoneNumber?.phoneNumber) {
    return contract.customer.defaultPhoneNumber.phoneNumber;
  }
  if (contract.customer?.defaultAddress?.phone) {
    return contract.customer.defaultAddress.phone;
  }
  if (contract.customer?.addressesV2?.[0]?.phone) {
    return contract.customer.addressesV2[0].phone;
  }
  if (contract.deliveryMethod?.address?.phone) {
    return contract.deliveryMethod.address.phone;
  }
  return 'Not provided';
};
